//import { createFocusTrap } from 'focus-trap';
import controller from "../../../../Resources/Scripts/_Shared/controller";

function facilityLightbox(context) {
  if (!context) return;
  const openLightboxButton = context.previousElementSibling;
  if (!openLightboxButton) return;

  //const overlayFocusTrap = createFocusTrap(context);
  openLightboxButton.addEventListener("click", (e) => {
    e.preventDefault();
    const targetElement = document.querySelector(".facility_summary_product_list");
    if (targetElement && openLightboxButton.getAttribute('class') === 'facilitypage__cta--showpricelist') {
      targetElement.setAttribute('tabindex', '-1');
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      setTimeout(() => {
        targetElement.focus();
      }, 300);
    } else {
      context.style.display = "flex";
      // overlayFocusTrap.activate();
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = "fixed";
      document.body.style.overflowY = "scroll";
      document.body.style.width = "100%";
      const campaignLinkBlock = context.querySelector(
        ".facilitypage__campaign__linkblock"
      );
      if (campaignLinkBlock) {
        const main = context.querySelector("main");
        const footer = context.querySelector("footer");
        const linkBlockInView =
          main.offsetHeight >
          campaignLinkBlock.offsetTop - campaignLinkBlock.offsetHeight;
        if (linkBlockInView) footer.style.backgroundColor = "#f5f7f8";
        else {
          let colorChanged = false;
          main.addEventListener("scroll", () => {
            const changeColor =
              main.scrollTop + main.offsetHeight >
              campaignLinkBlock.offsetTop -
                campaignLinkBlock.offsetHeight * 0.75;
            if (!colorChanged && changeColor) {
              footer.style.backgroundColor = "#f5f7f8";
              colorChanged = true;
            } else if (colorChanged && !changeColor) {
              footer.style.backgroundColor = "#fff";
              colorChanged = false;
            }
          });
        }
      }
    }
  });

  document.addEventListener("click", (e) => {
    if (
      !e.target.classList.contains("facilitypage__cta--showpricelist") &&
      (e.target.classList.contains("facilitypage__lightbox") ||
        e.target.classList.contains("facilitypage__lightbox__close"))
    ) {
      context.style.display = "none";
      //overlayFocusTrap.deactivate();
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  });
}

controller.add("facility-lightbox", facilityLightbox);
